import { render, staticRenderFns } from "./FloorSearch.vue?vue&type=template&id=63b895ac&"
import script from "./FloorSearch.vue?vue&type=script&lang=js&"
export * from "./FloorSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports